import * as atoms from "./atoms"
import * as molecules from "./molecules"
import * as organisms from "./organisms"
import * as templates from "./templates"
import type { App } from "vue"

export function registerComponents(app: App) {
  [atoms, molecules, organisms, templates].forEach(group => {
    Object.entries(group).forEach(([name, component]) => {
      app.component(name, component);
    });
  });
}

export * from "./atoms"
export * from "./molecules"
export * from "./organisms"
export * from "./templates"

export { atoms, molecules, organisms, templates };
export default { atoms, molecules, organisms, templates };
